import { render, staticRenderFns } from "./SuperAdminModuleSettings.vue?vue&type=template&id=14f1d90a&"
import script from "./SuperAdminModuleSettings.vue?vue&type=script&lang=js&"
export * from "./SuperAdminModuleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports